import { Modal } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { LabKitShipmentDetails } from './LabKitShipmentDetails';

type LabKitShipmentModalProps = {
  status: string;
  description: string;
  trackingNumber: string;
  isOpen: boolean;
  onClose: () => void;
  supportLink: string;
  shouldShowSupportLink: boolean;
};

export const LabKitShipmentModal = ({
  status,
  description,
  trackingNumber,
  isOpen,
  onClose,
  supportLink,
  shouldShowSupportLink,
}: LabKitShipmentModalProps) => {
  const { t } = useTranslation(['labs', 'global']);

  const modalTitle = t('labs:LabKit');
  const closeLabel = t('global:CloseDialog');

  return (
    <Modal.Root
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Modal.Content
        title={modalTitle}
        ariaLabel={modalTitle}
        closeAriaLabel={closeLabel}
        showXinDialog
      >
        <Modal.Body>
          <LabKitShipmentDetails
            status={status}
            description={description}
            trackingNumber={trackingNumber}
            supportLink={supportLink}
            shouldShowSupportLink={shouldShowSupportLink}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
